import { render } from "./DistrictZoneExecutiveList.vue?vue&type=template&id=83a77232&scoped=true"
import script from "./DistrictZoneExecutiveList.vue?vue&type=script&lang=js"
export * from "./DistrictZoneExecutiveList.vue?vue&type=script&lang=js"

import "./DistrictZoneExecutiveList.vue?vue&type=style&index=0&id=83a77232&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83a77232"]])

export default __exports__